import styles from "./VideoMenu.module.css";
import { createStyles, Fab, makeStyles, Theme } from "@material-ui/core";
import Menu, { SubMenu, Item as MenuItem } from "rc-menu";
import React, { useState, useCallback, memo, useEffect } from "react";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import "./rc-menu.css";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { isAdmin, isEditor } from "../../../utils/LogicUtils";
import { AddVideoToProgram, GetAllProgram } from "../../../stores/program/ProgramActions";
import { AddVideoToRec, GetRecVideoList, ResetRecVideos } from "../../homePage/HomePageActions";
// import {AddVideoToProject, GetAllProjectList} from "../../../store/actions/ExProjectActions";
import PuiMessage from "../../../components/widgets/PuiMessage";

interface VideoMenuProps {
    videoId: number;
    setMsg: (msg: string) => void;
    setIsShowing?: (target: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            marginLeft: "5px",
            marginTop: "5px",
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            "&:hover": {
                backgroundColor: "rgb(255, 255, 255, 0.9)",
            },
        },
    })
);

function VideoMenu({ videoId, setMsg, setIsShowing }: VideoMenuProps) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { user, userInfo } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        user: state.user.user,
    }));

    const { allProgramList } = useSelector(({ program }: AppState) => program);
    // const {projectList} = useSelector(({exProject}: AppState) => exProject);
    const { recommendVideoList } = useSelector(({ recommendList }: AppState) => recommendList);

    const [showMenu, setShowMenu] = useState<boolean>(false);

    useEffect(() => {
        if (showMenu === true) {
            if (allProgramList.length === 0) {
                if (userInfo) dispatch(GetAllProgram(userInfo.id));
            }
            if (recommendVideoList.length === 0) {
                if (userInfo) dispatch(GetRecVideoList(userInfo.id));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showMenu]);

    const handleOuterClick = useCallback(() => {
        setShowMenu(false);
        document.removeEventListener("click", handleOuterClick);
    }, []);

    const handleMenuIcon = useCallback(
        (toSet: boolean) => () => {
            document.dispatchEvent(new Event("click"));

            setShowMenu(toSet);

            if (toSet) {
                document.addEventListener("click", handleOuterClick);
            } else {
                document.removeEventListener("click", handleOuterClick);
            }
        },
        [setShowMenu, handleOuterClick]
    );

    const handlePropagation = useCallback((event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
    }, []);

    const [isLimitRecommendVideos, ChangeLimitRecommendVideos] = React.useState(false);
    const [recommendVideoNum, ChangeRecommendVideoNum] = React.useState(0);
    const [isDuplicatedRec, setIsDuplicatedRec] = React.useState(false);

    const handleAddToRecVideo = (title: string) => {
        setShowMenu(false);
        let dupRec = recommendVideoList?.find((el) => {
            return el.id.toString() === videoId.toString();
        });
        if (!dupRec) {
            if (recommendVideoNum < 10) {
                setMsg(title.replaceAll("recommendVideo", "おすすめVideo"));
                dispatch(AddVideoToRec(videoId.toString()));
                dispatch(ResetRecVideos());
            } else {
                ChangeLimitRecommendVideos(true);
            }
        } else {
            setIsDuplicatedRec(true);
        }
    };

    const CloseLimitRecommendVideoBar = () => {
        ChangeLimitRecommendVideos(false);
    };
    const CloseDuplicateRecommendVideoBar = () => {
        setIsDuplicatedRec(false);
    };

    useEffect(() => {
        if (showMenu === true) {
            ChangeRecommendVideoNum(Object.keys(recommendVideoList).length);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recommendVideoList]);

    const [isDuplicatedEpisode, setIsDuplicatedEpisode] = React.useState(false);
    const [isDuplicatedRelateVideo, setIsDuplicatedRelateVideo] = React.useState(false);

    const handleAddToProgram = (title: string, id: string) => {
        setShowMenu(false);
        if (title.includes("episode")) {
            let targetVideos = allProgramList.find((pro) => {
                return pro.id === id;
            });
            let dupVideo = targetVideos?.videos.find((el) => {
                return el.id.toString() === videoId.toString();
            });
            if (userInfo && !dupVideo) {
                setMsg(title.replaceAll("episode", "エピソード"));
                dispatch(AddVideoToProgram(userInfo.id, id, videoId.toString(), 1));
            } else {
                setIsDuplicatedEpisode(true);
            }
        } else if (title.includes("relationVideo")) {
            let targetVideos = allProgramList.find((pro) => {
                return pro.id === id;
            });
            let dupRelatedVideo = targetVideos?.relatedVideos.find((el) => {
                return el.id.toString() === videoId.toString();
            });
            if (userInfo && !dupRelatedVideo) {
                setMsg(title.replaceAll("relationVideo", "関連するVideo"));
                if (userInfo) dispatch(AddVideoToProgram(userInfo.id, id, videoId.toString(), 2));
            } else {
                setIsDuplicatedRelateVideo(true);
            }
        }
    };

    const CloseDuplicatedEpisodeBar = () => {
        setIsDuplicatedEpisode(false);
    };
    const CloseDuplicatedRelatedBar = () => {
        setIsDuplicatedRelateVideo(false);
    };

    const [isDuplicated, setIsDuplicated] = React.useState(false);

    // const handleAddToProject = (title: string, id: string) => {
    //     setShowMenu(false);
    //     let project = projectList.find((pro) => {
    //         return pro.id === id
    //     })
    //     let duplicated = project?.videos.find((el) => {
    //         return el.id === videoId.toString()
    //     })
    //     if(userInfo && !duplicated) {
    //         setMsg(title);
    //         if(userInfo) dispatch(AddVideoToProject(userInfo.id, id, videoId.toString()));
    //     } else {
    //         setIsDuplicated(true)
    //     }
    // };

    const CloseDuplicatedProjectBar = () => {
        setIsDuplicated(false);
    };

    useEffect(() => {
        if (setIsShowing) {
            setIsShowing(showMenu);
        }
        // eslint-disable-next-line
    }, [showMenu]);

    return (
        <>
            {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                <div className={styles.menuArea} onClick={handlePropagation}>
                    <Fab
                        variant="circular"
                        size="small"
                        className={classes.icon}
                        onClick={handleMenuIcon(!showMenu)}
                    >
                        <PlaylistAddIcon style={{ color: "var(--button-bg)" }} />
                    </Fab>

                    <Menu className={showMenu ? styles.menu : styles.nomenu} selectable={false}>
                        <MenuItem
                            key="recommendVideo"
                            onClick={() => handleAddToRecVideo("recommendVideo")}
                        >
                            おすすめVideo
                        </MenuItem>
                        <SubMenu title="Channel" key="Program">
                            {allProgramList.length > 0 &&
                                allProgramList.map((item) => (
                                    <SubMenu title={item.title} key={item.id}>
                                        <MenuItem
                                            key={`Program-${item.id}-episode`}
                                            onClick={() =>
                                                handleAddToProgram(
                                                    `Program-${item.title}-episode`,
                                                    item.id
                                                )
                                            }
                                        >
                                            エピソード
                                        </MenuItem>
                                        <MenuItem
                                            key={`Program-${item.id}-relationVideo`}
                                            onClick={() =>
                                                handleAddToProgram(
                                                    `Program-${item.title}-relationVideo`,
                                                    item.id
                                                )
                                            }
                                        >
                                            関連するVideo
                                        </MenuItem>
                                    </SubMenu>
                                ))}
                            {allProgramList.length === 0 && (
                                <MenuItem key="noProgramData" disabled>
                                    Channelがありません
                                </MenuItem>
                            )}
                        </SubMenu>
                        {/* <SubMenu title="Project" key="Project">
                            {
                                projectList.length > 0 && 
                                projectList.map((item) => (
                                    <MenuItem 
                                        key={`Project-${item.id}`} 
                                        onClick={() => handleAddToProject(`Project-${item.title}`, item.id)}
                                    >
                                        {item.title}
                                    </MenuItem>
                                ))
                            }
                            {
                                projectList.length === 0 && 
                                <MenuItem key="noProjectData" disabled>
                                    Projectがありません
                                </MenuItem>
                            }
                        </SubMenu> */}
                    </Menu>

                    <PuiMessage
                        open={isLimitRecommendVideos}
                        type="error"
                        title="おすすめVideoは、すでに10件登録されているので追加できません"
                        duration={5000}
                        onClose={CloseLimitRecommendVideoBar}
                    />
                    <PuiMessage
                        open={isDuplicatedRec}
                        type="error"
                        title="このVideoは既におすすめVideoに登録されています"
                        duration={5000}
                        onClose={CloseDuplicateRecommendVideoBar}
                    />
                    <PuiMessage
                        open={isDuplicatedEpisode}
                        type="error"
                        title="このVideoは既に選択したChannelのエピソードに登録されています"
                        duration={5000}
                        onClose={CloseDuplicatedEpisodeBar}
                    />
                    <PuiMessage
                        open={isDuplicatedRelateVideo}
                        type="error"
                        title="このVideoは既に選択したChannelの関連Videoに登録されています"
                        duration={5000}
                        onClose={CloseDuplicatedRelatedBar}
                    />
                    <PuiMessage
                        open={isDuplicated}
                        type="error"
                        title="このVideoは既に選択したProjectに登録されています"
                        duration={5000}
                        onClose={CloseDuplicatedProjectBar}
                    />
                </div>
            )}
        </>
    );
}

export default memo(VideoMenu);
